import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../Common/Footer';
import { AffiliatorSidebar } from '../Common/AffiliatorSidebar';
import { Header } from '../Common';
import FollowFavourites from '../../Models/FollowFavourites';
import Common from "../../Models/Common";
class AffiliatorFollowersBuyer extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 3) {
            alert(this.props.t('0'))
            this.props.history.push('/login/affiliator');
        };
        this.state = {
            _id: false,
            followings: [],
            logged_user_id: '',
            followingsMessage: '',
        };
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        this.state.logged_user_id = logged_user.id;
        this.getMyFollowings();
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    getMyFollowings() {
        FollowFavourites.getFollowings(this.state.logged_user_id).then(res => {
            if (res.data.status === 200) {
                this.setState({ followings: res.data.payload })
            } else {
                this.setState({ followingsMessage: res.data.message })
            }
        })
    }
    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //For Mobile view
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5"></div>
                    <div className="container-fluid">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                <AffiliatorSidebar />
                            </div> */}
                            <div className="col-md-8">
                                <div className=" input_name big_font " style={{ width: '100%',fontSize:'20px' ,textAlign:'left'}}>
                                    {this.props.t('1')}
                                </div>
                                {(() => {
                                    if (this.state.followings.length === 0) {
                                        return (
                                            <div></div>
                                        )
                                    } else {
                                        return (
                                            <div style={{ border: "1px solid #bababa", minHeight: "550px" }}>
                                                {this.state.followings.map(group =>
                                                    <div className="service-list-divs" style={{ textAlign: 'left' }}>
                                                        <div className="" style={{ padding: "4%" }}>
                                                            <img className="rounded-circle" style={{ borderRadius: "50%" }} alt="" src={Common.baseUrl + group.img} height="50" width='50' />&nbsp;&nbsp;
                                                            <Link to={{
                                                                pathname: `/my-profile-view/users/${group.seller_id}`,
                                                                state: { id: group.seller_id }
                                                            }} className="sky-a ml-3">{group.first_name}
                                                            </Link>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )
                                    }
                                })()}
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <AffiliatorSidebar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mb-1 input_name big_font text-left" style={{ width: '100%' }}>
                                            {this.props.t('1')}
                                    </div>
                                        {(() => {
                                            if (this.state.followings.length === 0) {
                                                return (
                                                    <div></div>
                                                )
                                            } else {
                                                return (
                                                    <div style={{ border: "1px solid #bababa", minHeight: "550px" }}>
                                                        {this.state.followings.map(group =>
                                                            <div className="service-list-divs" style={{ textAlign: 'left' }}>
                                                                <div className="" style={{ padding: "4%" }}>
                                                                    <img className="rounded-circle" style={{ borderRadius: "50%" }} alt="" src={Common.baseUrl + group.img} height="50" width='50' />&nbsp;&nbsp;
                                                                <Link to={{
                                                                        pathname: `/my-profile-view/users/${group.seller_id}`,
                                                                        state: { id: group.seller_id }
                                                                    }} className="sky-a ml-3">{group.first_name}
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )
                                            }
                                        })()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
export { AffiliatorFollowersBuyer }


 AffiliatorFollowersBuyer = withTranslation('src_Components_Followers_AffiliatorFollowersBuyer')(AffiliatorFollowersBuyer);